import Navb from "./nav/nav"
import Home from './home/home'
import SobreMiEn from "./sobremi/sobremien"
import SobreMi2En from "./sobremi2/sobremi2en"
import Galeria from "./galeria/galeria"
import Clases from "./clases/clases"
import Prensa from "./prensa/prensa"
import Footer from "./footer/footer"
import ContactoMain from "./contactoMain/contactoMain"
import Eventos from "./eventosprivados/eventosprivados"



function HomeEN() {
    return (
        <div>
            <Navb></Navb>
            <Home></Home>
            <SobreMiEn></SobreMiEn>
            <SobreMi2En></SobreMi2En>
            <Galeria></Galeria>
            <Clases></Clases>
            <Eventos></Eventos>
            <Prensa></Prensa>
            <ContactoMain></ContactoMain>
            <Footer></Footer>
        </div>
    )
}

export default HomeEN